import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Team} from "../../../../core/models/team.model";
import {Router} from "@angular/router";
import {UserStorage} from "../../../../core/storage/user.storage";
import {ROLE_LIST} from "../../../../core/common/constant";
import {filter, take} from "rxjs/operators";
import {BsModalService} from "ngx-bootstrap/modal";
import {TeamService} from "../../../../core/services/team.service";
import {ConfirmDeleteTeamComponent} from '../confirm-delete-team/confirm-delete-team.component';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {TeamValidator} from '../../team.validator';
import {CONFIG} from '../../../../core/config/application.config';

@Component({
    selector: 'app-team-table',
    templateUrl: './team-table.component.html',
    styleUrls: ['./team-table.component.css']
})
export class TeamTableComponent implements OnInit, OnChanges{

    @Input() teamList: Team[] = [];
    @Input() page = 0;
    @Input() size = 0;
    @Input() summary = {
        average_effort: 0,
        total_member: 0,
        total_productivity: 0,
        total_salary: 0
    };
    @Output() reload = new EventEmitter<any>();
    displayList: any[] = [];
    canViewSalary = false;
    canDeleteTeam = false;
    constructor(public router: Router,
                private teamService: TeamService,
                private modalService: BsModalService,
                private userStorage: UserStorage,
                private toastService: ToastrService,
                public translate: TranslateService,
                private teamValidator: TeamValidator) {
        this.canDeleteTeam = this.teamValidator.validatePermission(CONFIG.PERMISSION.ACTION.DELETE_TEAM, false);
    }

    ngOnInit(): void {
        const roles = (this.userStorage.getUserRoles() as any[]) || [];
        const allowViewSalaryRole = [
            ROLE_LIST.COO, ROLE_LIST.C_B, ROLE_LIST.COO,
            ROLE_LIST.CEO, ROLE_LIST.OM, ROLE_LIST.PRM,
            ROLE_LIST.TEAM_LEADER
        ]
        this.canViewSalary = roles.some(role => allowViewSalaryRole.includes(role.code));

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['teamList'] && this.teamList) {
            this.displayList = this.teamList.map(team => ({
                ...team,
                domains: team.domains.map(el => el.domain.name).join(', '),
                technologies: team.technologies.map(el => el.technology.name).join(', ')
            }))
        }
    }

    openConfirmDelete(team:Team): void {
        if (!this.canDeleteTeam) return;
        const ref = this.modalService.show(ConfirmDeleteTeamComponent, {
            class: 'modal-left modal-dialog-centered w-50 max-width-modal expand',
            ignoreBackdropClick: true
        });

        ref.content.confirmSubject$.pipe(
            filter(val => !!val),
            take(1)
        ).subscribe(confirm => {
            if (confirm) {
                this.teamService.deleteTeam({team_id: team.team_id}).subscribe(data => {
                    this.toastService.success(this.translate.instant('TEAM.DELETE.SUCCESS'));
                    this.reload.emit(true);
                }, error => {
                    this.toastService.error(error.error.status.message);
                });
            }
        })

    }

}
